export default __webpack_public_path__ + "static/Longrass-8c9ab6b8e73e63e323bae19ab671a17a.png";